export function initiateTableFilter() {
	const filterForm = document.getElementById('tableFilterForm');
	const activeFiltersDiv = document.getElementById('activeFilters');
	const tagFilterForms = document.querySelectorAll('.tag-filter-form');

	if (filterForm && activeFiltersDiv) {


		// Load filters from URL on page load
		loadFiltersFromURL(activeFiltersDiv);

		// Handle form submission
		filterForm.addEventListener('submit', function (e) {
			e.preventDefault();
			applyFilters(filterForm);
		});

	}

	// Handle tag filter form submissions
	if (tagFilterForms) {
		tagFilterForms.forEach(form => {
			form.addEventListener('submit', function (e) {
				e.preventDefault();
				const tagTitle = form.getAttribute('data-tag-title');
				const tagInput = form.querySelector('.tag-filter-input');
				if (tagInput && tagTitle) {
					const tagTitleCleaned = tagTitle.toLowerCase().replace(/\s+/g, '_');
					const tagValue = tagInput.value.trim();
					const urlParams = new URLSearchParams(window.location.search);

					if(urlParams.get('tag') === tagTitleCleaned && urlParams.get('tag_value') === tagValue) {
						return; // No change, do nothing
					}
					urlParams.set('tag', tagTitleCleaned);
					urlParams.set('tag_value', tagValue);
					urlParams.delete('page');
					const newURL = window.location.pathname + '?' + urlParams.toString();
					window.location.href = newURL;
				}
			});
		});
	}
}

function applyFilters(filterForm) {
	// const formData = new FormData(filterForm);
	const urlParams = new URLSearchParams(window.location.search);

	// Clear existing filter parameters
	urlParams.delete('caller_id');
	urlParams.delete('disposition');
	urlParams.delete('vertical_type');
	urlParams.delete('page'); // Reset to first page on new filter

	// Add form values to URL
	const callerIdValue = document.getElementById('callerIdInput').value.trim().replace(/[^0-9 ]/g, '');
	const dispositionValue = document.getElementById('dispositionInput').value.trim();
	const verticalTypeValueInput = document.getElementById('verticalTypeInput');
	let verticalTypeValue;
	if (verticalTypeValueInput) {
		verticalTypeValue = verticalTypeValueInput.value.trim();
	}
	const cost = document.getElementById('costFilter').value.trim();
	const converted = document.getElementById('converted').value.trim();

	if (callerIdValue) {
		urlParams.set('caller_id', callerIdValue);
	}
	if (dispositionValue) {
		urlParams.set('disposition', dispositionValue);
	}
	if (verticalTypeValue) {
		urlParams.set('vertical_type', verticalTypeValue);
	}
	if (cost) {
		urlParams.set('cost_filter', cost);
	}
	if (converted) {
		urlParams.set('converted', converted);
	}

	// Update URL and reload page
	const newURL = window.location.pathname + '?' + urlParams.toString();
	window.location.href = newURL;
}

function loadFiltersFromURL(activeFiltersDiv) {
	const urlParams = new URLSearchParams(window.location.search);

	// Populate form fields with URL parameters
	const callerIdParam = urlParams.get('caller_id');
	const dispositionParam = urlParams.get('disposition');
	const verticalTypeParam = urlParams.get('vertical_type');
	const costParam = urlParams.get('cost');
	const convertedParam = urlParams.get('converted');

	if (costParam) {
		document.getElementById('cost').value = costParam;
	}
	if (convertedParam) {
		document.getElementById('converted').value = convertedParam;
	}
	if (callerIdParam) {
		document.getElementById('callerIdInput').value = callerIdParam;
	}
	if (dispositionParam) {
		document.getElementById('dispositionInput').value = dispositionParam;
	}
	if (verticalTypeParam) {
		document.getElementById('verticalTypeInput').value = verticalTypeParam;
	}

	// Display active filters
	displayActiveFilters(activeFiltersDiv);
}

function displayActiveFilters(activeFiltersDiv) {
	const urlParams = new URLSearchParams(window.location.search);
	activeFiltersDiv.innerHTML = '';

	const filters = [
		{ key: 'caller_id', label: 'Caller ID' },
		{ key: 'disposition', label: 'Disposition' },
		{ key: 'vertical_type', label: 'Vertical Type' },
		{ key: 'cost', label: 'Cost' },
		{ key: 'converted', label: 'Converted' }
	];

	filters.forEach(filter => {
		const value = urlParams.get(filter.key);
		if (value) {
			const filterBadge = document.createElement('span');
			filterBadge.className = 'badge badge--primary me-2 mb-2';
			filterBadge.innerHTML = `
                    ${filter.label}: ${value}
                    <button type="button" class="btn-close btn-close-white" onclick="removeFilter('${filter.key}')" aria-label="Close"></button>
                `;
			activeFiltersDiv.appendChild(filterBadge);
		}
	});
}